@if (lineItems(); as orderLineItems) {
  <table mat-table [dataSource]="orderLineItems">

    <ng-container matColumnDef="date" [sticky]="true">
      <th mat-header-cell *matHeaderCellDef> Dato</th>
      <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ element.date | date }}</td>
    </ng-container>

    <ng-container matColumnDef="productName" [sticky]="true">
      <th mat-header-cell *matHeaderCellDef> Produkttitel og SKU</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-1">
          <span>{{ element.productTitle }}</span>
          <span class="small-text">
              @if (!hideStoreName()) {
                Købt: {{ getHumanStoreName(element.storeName) }} •
              }
            SKU: {{ element.sku }}
            </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="qty" [sticky]="true">
      <th mat-header-cell *matHeaderCellDef> Antal</th>
      <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ element.quantity }} {{ element.unitType }}</td>
    </ng-container>

    <ng-container matColumnDef="unitPrice" [stickyEnd]="true">
      <th mat-header-cell *matHeaderCellDef> Stykpris</th>
      <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ element.unitPrice | price | currency }}
        kr./{{ element.unitType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalPrice" [stickyEnd]="true">
      <th mat-header-cell *matHeaderCellDef> Linjetotal</th>
      <td mat-cell *matCellDef="let element" class="text-nowrap"> {{ element.lineTotal | price | currency }} kr.</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>
  </table>
  @if (showPagination()) {
    <mat-paginator [length]="totalItems()" [pageSize]="100" (page)="changePage($event)" [pageIndex]="pageIndex()"
                   [hidePageSize]="true"></mat-paginator>
  }
}
